export default function removePost(oldPosts, postId) {
  const posts = oldPosts.filter((oldPost) => {
    if (oldPost.replies.length > 0) {
      return oldPost.replies.filter((reply) => reply.id !== postId);
    }
    return oldPost.id !== postId;
  });
  return posts;
}
